
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { BusinessUnitUpdateDto_$reflection, BusinessUnitUpdateDto, BusinessUnitDetailDto_$reflection } from "../../Shared/BusinessUnit.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { BusinessUnitId__get_unwrap } from "../../Shared/Shared.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ensureRequestBodySize } from "../../ErrorHandling.js";
import { onBlobReceived } from "../../CommunicationV2.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

function initState(businessUnitId) {
    return new State(new RequestedValue$1(0, []), businessUnitId, FormState_get_empty());
}

export function initViewBusinessUnit(businessUnitId, userData) {
    return [initState(businessUnitId), Cmd_batch(singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), BusinessUnitDetailDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/business-units/", ...BusinessUnitId__get_unwrap(businessUnitId)), (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(8, [Item_1])))))];
}

export function update(msg, state) {
    let body, body_3;
    switch (msg.tag) {
        case 2: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.BusinessUnit, state.BusinessUnitId, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_1 = state.BusinessUnit;
                if (matchValue_1.tag === 0) {
                    return [state, Cmd_none()];
                }
                else {
                    const businessUnit = matchValue_1.fields[0];
                    const dto = new BusinessUnitUpdateDto(businessUnit.Name, businessUnit.Description, businessUnit.ParentId, undefined);
                    return [state, (body = toString(0, Auto_generateBoxedEncoder_437914C6(BusinessUnitUpdateDto_$reflection(), undefined, undefined, undefined)(dto)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(tupledArg[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_3) => {
                            const pr_1 = response_3.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                        }, refreshOn_1)))(true);
                    })), [concat("/api/business-units/", ...BusinessUnitId__get_unwrap(state.BusinessUnitId)), body], (Item_2) => (new Msg(7, [Item_2])), (Item_3) => (new Msg(8, [Item_3]))))];
                }
            }
        }
        case 0: {
            const file = msg.fields[0];
            if (state.BusinessUnit.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const formData = new FormData();
                formData.append(file.name, file);
                return [new State(state.BusinessUnit, state.BusinessUnitId, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg_1) => {
                    const formData_2 = tupledArg_1[1];
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_8;
                        ensureRequestBodySize(formData_2);
                        return ((url_8 = addPrefix(tupledArg_1[0]), (refreshOn_2) => fetchWithDecoder(url_8, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response_5) => {
                            const pr_2 = response_5.arrayBuffer();
                            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), string_type));
                        }, refreshOn_2)))(true);
                    }));
                }, ["/api/business-units/image", formData], (Item_4) => (new Msg(3, [Item_4])), (Item_5) => (new Msg(8, [Item_5])))];
            }
        }
        case 3: {
            const response_7 = msg.fields[0];
            if (response_7.tag === 1) {
                return [new State(state.BusinessUnit, state.BusinessUnitId, FormState__setValidationResponse_5219762A(state.FormState, response_7.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_3 = state.BusinessUnit;
                if (matchValue_3.tag === 0) {
                    return [state, Cmd_none()];
                }
                else {
                    const businessUnit_1 = matchValue_3.fields[0];
                    const dto_2 = new BusinessUnitUpdateDto(businessUnit_1.Name, businessUnit_1.Description, businessUnit_1.ParentId, response_7.fields[0]);
                    return [state, (body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(BusinessUnitUpdateDto_$reflection(), undefined, undefined, undefined)(dto_2)), Cmd_OfPromise_either((tupledArg_2) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_11;
                        return ((url_11 = addPrefix(tupledArg_2[0]), (refreshOn_3) => fetchWithDecoder(url_11, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_2[1]])]), "application/json", (response_8) => {
                            const pr_3 = response_8.arrayBuffer();
                            return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), string_type));
                        }, refreshOn_3)))(true);
                    })), [concat("/api/business-units/", ...BusinessUnitId__get_unwrap(state.BusinessUnitId)), body_3], (Item_6) => (new Msg(7, [Item_6])), (Item_7) => (new Msg(8, [Item_7]))))];
                }
            }
        }
        case 4: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 5:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.BusinessUnitId, state.FormState), Cmd_none()];
        case 6:
            return [state, Cmd_batch(singleton(Cmd_ofEffect((_arg) => {
                RouterModule_nav(singleton("/business-units"), 1, 1);
            })))];
        case 7: {
            const response_11 = msg.fields[0];
            if (response_11.tag === 1) {
                return [new State(state.BusinessUnit, state.BusinessUnitId, FormState__setValidationResponse_5219762A(state.FormState, response_11.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else if (state.BusinessUnit.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.BusinessUnit, state.BusinessUnitId, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), Cmd_OfPromise_either((url_12) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_14;
                    return ((url_14 = addPrefix(url_12), (refreshOn_4) => fetchWithDecoder(url_14, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_12) => {
                        const pr_4 = response_12.arrayBuffer();
                        return pr_4.then((blob_5) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_5)), BusinessUnitDetailDto_$reflection()));
                    }, refreshOn_4)))(true).then((_arg_1) => {
                        const result_5 = _arg_1;
                        return (result_5.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_5.fields[0]);
                        })())) : (Promise.resolve(result_5.fields[0]));
                    });
                })), concat("/api/business-units/", ...BusinessUnitId__get_unwrap(state.BusinessUnitId)), (Item_8) => (new Msg(5, [Item_8])), (Item_9) => (new Msg(8, [Item_9])))]))];
            }
        }
        case 8:
            return [new State(state.BusinessUnit, state.BusinessUnitId, FormState_get_empty()), Cmd_none()];
        default:
            if (state.BusinessUnit.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.BusinessUnit, state.BusinessUnitId, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), "/api/business-units/image", (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(8, [Item_1])))];
            }
    }
}

